import React, { Component } from 'react'
import { connect } from 'react-redux'
import { catchJSException } from './../../../serviceSMB/logService';

class Compatibility extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: '',

        }
    }


    loadProducts = (name) => {
        try {
            this.setState({
                selectedValue: name
            })
            // let selectedValue=[];
            // selectedValue.push(name);


        } catch (ex) {
            catchJSException('compatibility', this.props.appState.visitId, 'loadProducts', ex);
        }
    }

    render() {
        let compatabilityValues = [];
        if (this.props.compatibilityValue && this.props.compatibilityValue.compatibilityList) {
            this.props.compatibilityValue.compatibilityList.map((compatibilityValueitems, index) => (
                compatabilityValues.push(
                    <li >
                        <input className="value" type="checkbox" checked={this.props.preSelection("compatibility", (compatibilityValueitems.name).toLocaleLowerCase())}
                            id={compatibilityValueitems.name} onClick={() => this.props.action("compatibility", (compatibilityValueitems.name).toLocaleLowerCase())} />
                        <label htmlFor={compatibilityValueitems.name} role="checkbox" aria-checked="false"  >
                            <span className="bg-black" ></span> {compatibilityValueitems.name} ({compatibilityValueitems.count})
                        </label>
                    </li>
                )))
        }

        return (
            <React.Fragment>
                <div  >
                    <li className="m_accordion-details" style={{ display: this.props.showCompatibility ? 'none' : 'block' }}>
                        <ul className="no-bullet margin-bottom-zero" filter-option="compatability" data-checkbox-options="">
                            {compatabilityValues}
                        </ul>
                    </li>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {

        cartProduct: state.cartProductDataSMB,
        filterDataValue: state.productsSMB.filterData,
        appState: state.appSMB
    }
}
export default (connect(
    mapStateToProps
)(Compatibility));
